export const formLocale = {
  fileButton: {
    en: 'Click to upload',
    'pt-br': 'Clique para carregar',
    es: 'Haga clic para cargar',
    id: 'Klik untuk mengunggah',
    fr: 'Cliquez pour télécharger',
    it: 'Fare clic per caricare',
    de: 'Zum Hochladen klicken',
    zh: '点击上传',
    ru: 'Нажмите, чтобы загрузить',
  },
};
